export const SERVER_TO_CLIENT_EVENTS = {
    error: "error",
    connect_failed: "connect_failed",
    connect: "connect",
    connect_error: "connect_error",
    readd: "readd",
    registered: "registered",
    duplicate: "duplicate",
    kick: "kick",
    system: "system",
    user: "user",
    support: "fms",
    disconnect: "disconnect",
    typeinfo: "typeinfo",
};
export const CLIENT_TO_SERVER_EVENTS = {
    sendLine: "sendLine",
    register: "register",
};
